<template>
  <div>
    установка приложения возможна только с телефона, для ios <b>safari</b>, для adnroid <b>chrome</b>.
  </div>
</template>

<script>
  export default {
    name: "browserError"
  }
</script>

<style scoped>

</style>
